import script from "./MmMyClaims.vue?vue&type=script&setup=true&lang=js"
export * from "./MmMyClaims.vue?vue&type=script&setup=true&lang=js"

import "./MmMyClaims.vue?vue&type=style&index=0&id=3e36ddfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e36ddfa"]])

export default __exports__